import { render, staticRenderFns } from "./grid-column-cmp.vue?vue&type=template&id=af5cdc2c&scoped=true&functional=true"
import script from "./grid-column-cmp.vue?vue&type=script&lang=js"
export * from "./grid-column-cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "af5cdc2c",
  null
  
)

export default component.exports